import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import styled from "styled-components";
import BackgroundImage from "gatsby-background-image";

const Hero = () => {
  const { hero } = useStaticQuery(graphql`
    query {
      hero: file(name: { eq: "news-banner" }) {
        sharp: childImageSharp {
          fluid(maxWidth: 1500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);

  return (
    <StyledBackgroundImage Tag="section" fluid={hero.sharp.fluid}>
      <div className="relative grid grid-cols-8 md:grid-cols-12 z-20 p-1 pt-4 lg:pt-20 text-white lg:mb-0 h-[60vh]">
        <div className="col-span-8 lg:block p-6">
          <h1 className="text-left font-light tracking-tight text-4xl sm:text-5xl lg:text-6xl">
            <span className="block text-primary">
              <span className="block sm:inline text-white font-bold">Latest News and Reports from Waivpay</span>
            </span>
          </h1>
        </div>
      </div>
    </StyledBackgroundImage>
  )
}

// Darken background image so doesn't clash with white text/content
const StyledBackgroundImage = styled(BackgroundImage)`
   &::before,
   &::after {
    filter: brightness(0.7);
  }
`;

export default Hero;

